import { useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import styles from "./style.module.scss";
import DocumentOtherChargesEditor from "@components/forms/DocumentOtherChargesEditor";
import {
    OpenDocumentOtherChargesPubSub,
    OpenDocumentOtherChargesPubSubPayload,
} from "@utils/pubsubs/PubSub";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setDocumentOtherCharges } from "@/store/slices/eDocumentSlides";
import { selectDocumentVentaNeta } from "@/store/slices/utils/eDocumentSelectors";
import { StoredOtherCharge } from "@utils/DocumentOtherCharges";

type DocumentOtherChargesOffCanvasProps = {} & DefaultOffCanvasProps;

const DocumentOtherChargesOffCanvas = (_props: DocumentOtherChargesOffCanvasProps) => {
    const dispatch = useAppDispatch();
    const persistedCharges = useAppSelector((state) => state.eDocument.documentOtherCharges);
    const ventaNeta = useAppSelector(selectDocumentVentaNeta);
    const currencySymbol = useAppSelector((state) => state.currency.currencySymbol) || "";
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [readonly, setReadonly] = useState<boolean>(false);
    const [draftCharges, setDraftCharges] = useState<StoredOtherCharge[]>([]);

    useEffect(() => {
        const unsubscribe = OpenDocumentOtherChargesPubSub.subscribe(handleOpenEvent);
        return () => {
            unsubscribe();
        };
    }, [persistedCharges]);

    const handleOpenEvent = (payload: OpenDocumentOtherChargesPubSubPayload) => {
        const { openOffCanvas = false, readonly: payloadReadonly = false } = payload;
        if (openOffCanvas) {
            setDraftCharges(persistedCharges);
            setReadonly(payloadReadonly);
        }
        setIsOpen(openOffCanvas);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleSave = () => {
        dispatch(setDocumentOtherCharges(draftCharges));
        setIsOpen(false);
    };

    return (
        <DefaultOffCanvas
            className={styles.offCanvas}
            direction="end"
            isOpen={isOpen}
            onClosed={handleClose}
            toggle={() => setIsOpen(false)}
        >
            <OffcanvasHeader className={styles.offCanvasHeader} toggle={handleClose}>
                Otros cargos del documento
            </OffcanvasHeader>
            <OffcanvasBody className={styles.body}>
                <Container>
                    <DocumentOtherChargesEditor
                        value={draftCharges}
                        onChange={setDraftCharges}
                        base={ventaNeta}
                        currencySymbol={currencySymbol}
                        readonly={readonly}
                    />
                </Container>
            </OffcanvasBody>
            <div className={styles.footer}>
                <Button color="secondary" type="button" onClick={handleClose}>
                    Cancelar
                </Button>
                {!readonly && (
                    <Button
                        color="primary"
                        type="button"
                        data-testid="other-charges-save-all"
                        onClick={handleSave}
                    >
                        Guardar cargos
                    </Button>
                )}
            </div>
        </DefaultOffCanvas>
    );
};

export default DocumentOtherChargesOffCanvas;
